import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedSvgModule } from '@warema/shared/svg';

@Component({
    selector: 'warema-appointments-status-legend',
    templateUrl: './appointments-status-legend.component.html',
    styleUrls: ['./appointments-status-legend.component.scss'],
    imports: [TranslatePipe, SharedSvgModule],
})
export class AppointmentsStatusLegendComponent {}
